import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'menHairLoss_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    educationalSlide: '',
    type: 'info',
    isLast: true,
    blockQuestionFlow: true,
    answer: {}
  },
  {
    field: 'menHairLoss_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'menHairLoss_sexAssignedAtBirth',
    extras: {
      sendToBeluga: false
    },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'menHairLoss_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'menHairLoss_height',
    type: 'info',
    answer: {
      name: 'menHairLoss_height',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'menHairLoss_weight',
    type: 'info',
    answer: {
      name: 'menHairLoss_weight',
      type: 'text',
      placeholder: 'Pounds'
    }
  },
  {
    label: 'Please identify all your current medical conditions',
    field: 'menHairLoss_currentMedicalConditions',
    type: 'info',
    answer: {
      name: 'menHairLoss_currentMedicalConditions_ans',
      type: 'text',
      placeholder: 'Medical conditions'
    }
  },
  {
    label: 'Please list all your current medications including dosages',
    field: 'menHairLoss_currentMedications',
    type: 'info',
    answer: {
      name: 'menHairLoss_currentMedications_ans',
      type: 'text',
      placeholder: 'Medications'
    }
  },
  {
    label: 'Please list all of your known allergies',
    field: 'menHairLoss_knownAllergies',
    type: 'info',
    answer: {
      name: 'menHairLoss_knownAllergies_ans',
      type: 'text',
      placeholder: 'Allergies'
    }
  },
  {
    label: 'Which areas are affected by hair loss?',
    field: 'menHairLoss_affectedAreas',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_affectedAreas_recedingHairline',
          value: 'Receding hairline'
        },
        {
          key: 'menHairLoss_affectedAreas_thinningAtCrown',
          value: 'Thinning at the crown'
        },
        {
          key: 'menHairLoss_affectedAreas_overallThinning',
          value: 'Overall thinning'
        },
        {
          key: 'menHairLoss_affectedAreas_other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: 'Tell us more about the pattern of your hair loss',
    field: 'menHairLoss_affectedAreas_other_more',
    type: 'info',
    answer: {
      name: 'menHairLoss_affectedAreas_other_more',
      type: 'text'
    }
  },
  {
    label: 'How long have you been experiencing hair loss?',
    field: 'menHairLoss_howLongHaveYouBeenExperiencingHairLoss',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_howLongHaveYouBeenExperiencingHairLoss_lessThan6Months',
          value: 'Less than 6 months'
        },
        {
          key: 'menHairLoss_howLongHaveYouBeenExperiencingHairLoss_6MonthsTo1Year',
          value: '6 months to 1 year'
        },
        {
          key: 'menHairLoss_howLongHaveYouBeenExperiencingHairLoss_over1Year',
          value: 'Over 1 year'
        }
      ]
    }
  },
  {
    label: 'How much hair have you lost?',
    field: 'menHairLoss_howMuchHairHaveYouLost',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_howMuchHairHaveYouLost_aLittle',
          value: 'A little (Only I notice it)'
        },
        {
          key: 'menHairLoss_howMuchHairHaveYouLost_some',
          value: 'Some (Those close to me notice it)'
        },
        {
          key: 'menHairLoss_howMuchHairHaveYouLost_aLot',
          value: 'A lot (It is obvious to everyone)'
        }
      ]
    }
  },
  {
    label: 'Do you believe your hair loss is due to:',
    field: 'menHairLoss_hairLossCause',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_hairLossCause_genetics',
          value: 'Genetics'
        },
        {
          key: 'menHairLoss_hairLossCause_stress',
          value: 'Stress'
        },
        {
          key: 'menHairLoss_hairLossCause_medicalConditions',
          value: 'Medical conditions'
        },
        {
          key: 'menHairLoss_hairLossCause_medications',
          value: 'Medications'
        },
        {
          key: 'menHairLoss_hairLossCause_nutritionalDeficiencies',
          value: 'Nutritional deficiencies'
        },
        {
          key: 'menHairLoss_hairLossCause_other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: 'Tell us more about why you think you are losing hair',
    field: 'menHairLoss_hairLossCause_other_why',
    type: 'info',
    answer: {
      name: 'menHairLoss_hairLossCause_other_why',
      type: 'text'
    }
  },
  {
    label:
      'Do you have any scalp conditions such as psoriasis, dermatitis, and/or recent or current scalp infections?',
    field: 'menHairLoss_scalpConditions',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_scalpConditions_yes',
          value: 'Yes'
        },
        {
          key: 'menHairLoss_scalpConditions_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have excessive dandruff, scalp irritation, scalp redness, burning, pustules, or scarring?',
    field: 'menHairLoss_scalpIrritation',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_scalpIrritation_yes',
          value: 'Yes'
        },
        {
          key: 'menHairLoss_scalpIrritation_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Are you losing hair in different parts of your body?',
    field: 'menHairLoss_hairLossInDifferentPartsOfBody',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_hairLossInDifferentPartsOfBody_yes',
          value: 'Yes'
        },
        {
          key: 'menHairLoss_hairLossInDifferentPartsOfBody_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Tell us more about your hair loss in other parts of your body.',
    field: 'menHairLoss_hairLossInDifferentPartsOfBody_more',
    type: 'info',
    answer: {
      type: 'text',
      name: 'menHairLoss_hairLossInDifferentPartsOfBody_more'
    }
  },
  {
    label: 'Have you tried any treatments for hair loss before?',
    field: 'menHairLoss_hairLossTreatments',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_hairLossTreatments_yes',
          value: 'Yes'
        },
        {
          key: 'menHairLoss_hairLossTreatments_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Tell us more about your previous treatment including product use, when, duration of use, and did you experience side effects?',
    field: 'menHairLoss_hairLossTreatments_yes_more',
    type: 'info',
    answer: {
      type: 'text',
      rows: 3,
      name: 'menHairLoss_hairLossTreatments_yes_more'
    }
  },
  {
    label:
      'Do you have any of the following medical conditions? (check all that apply)',
    field: 'menHairLoss_medicalConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'menHairLoss_medicalConditions_prostateCancer',
          value: 'Current or history of prostate cancer'
        },
        {
          key: 'menHairLoss_medicalConditions_liverCirrhosis',
          value: 'Liver disease such as liver cirrhosis'
        },
        {
          key: 'menHairLoss_medicalConditions_kidneyDisease',
          value:
            'Kidney disease such as chronic kidney disease or kidney failure'
        },
        {
          key: 'menHairLoss_medicalConditions_heartConditions',
          value: 'Heart conditions or cardiovascular diseases'
        },
        {
          key: 'menHairLoss_medicalConditions_stroke',
          value: 'History of stroke'
        },
        {
          key: 'menHairLoss_medicalConditions_pheochromocytoma',
          value: 'Pheochromocytoma (adrenal gland tumor)'
        },
        {
          key: 'menHairLoss_medicalConditions_pulmonaryHypertension',
          value: 'Pulmonary hypertension'
        },
        {
          key: 'menHairLoss_medicalConditions_erectileDysfunction',
          value: 'Erectile Dysfunction'
        },
        {
          key: 'menHairLoss_medicalConditions_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label:
      'Do you have a history of depression, bipolar disorder, anxiety, or other mood disorders?',
    field: 'menHairLoss_moodDisorders',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_moodDisorders_yes',
          value: 'Yes'
        },
        {
          key: 'menHairLoss_moodDisorders_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Can you tell us more about your mood disorder and whether it is controlled or uncontrolled?',
    field: 'menHairLoss_moodDisorders_yes_more',
    type: 'info',
    answer: {
      type: 'text',
      name: 'menHairLoss_moodDisorders_yes_more'
    }
  },
  {
    label: 'Do you plan on having children soon?',
    field: 'menHairLoss_planOnHavingChildrenSoon',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_planOnHavingChildrenSoon_yes',
          value: 'Yes'
        },
        {
          key: 'menHairLoss_planOnHavingChildrenSoon_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'menHairLoss_otherInformationOrQuestions',
    type: 'info',
    answer: {
      name: 'menHairLoss_otherInformationOrQuestions',
      type: 'text'
    }
  },
  {
    label: 'Consent Form for Hair Loss Treatment',
    educationalSlide: `
    Consent:

    Finasteride, minoxidil, and GUK-Cu are medications used to treat male pattern hair loss (androgenetic alopecia).

    Purpose of Treatment
    Finasteride: An oral medication that inhibits the conversion of testosterone to dihydrotestosterone (DHT), a hormone linked to hair loss. It helps slow hair loss and may promote regrowth.
    Minoxidil: A topical solution that stimulates hair follicles to promote hair growth. It increases blood flow to the scalp.
    GUK-Cu: A copper peptide complex believed to stimulate hair growth by enhancing blood flow and supporting scalp health.

    Potential Benefits
    These treatments aim to slow hair loss, promote new hair growth, and improve hair density and appearance.

    Contraindications
    Finasteride 
     - Individuals with liver disease        
     - Those with a history of prostate cancer        
     - Anyone allergic to finasteride or its components        
     - Women who are or may become pregnant should not handle finasteride tablets    

    Minoxidil        
     - Individuals with scalp conditions like dermatitis or psoriasis        
     - Those allergic to minoxidil or its components    
    
    GUK-Cu 
     - Should not be used by individuals allergic to copper peptides or any of its components    

    Potential Risks and Side Effects
    
    Finasteride    
     - Sexual dysfunction (decreased libido, erectile dysfunction)        
     - Breast tenderness or enlargement        
     - Depression or mood changes        
     - Allergic reactions        
     - Possible effect on PSA levels used in prostate cancer screening    
    Minoxidil
     - Scalp irritation, itching, or dryness        
     - Unwanted facial or body hair growth        
     - Changes in blood pressure or heart rate (rare)    
    GUK-Cu
     - Scalp irritation        
     - Allergic reactions    

    Monitoring and Follow-up
    Regular monitoring is recommended to assess effectiveness and detect any side effects. Inform your healthcare provider of any adverse reactions or concerns.
    Alternative Treatments
     - Hair transplant surgery        
     - Low-level laser therapy        
     - Platelet-rich plasma (PRP) therapy        
     - Lifestyle changes and acceptance of hair loss    

    Patient Responsibilities   
     - Use medications exactly as prescribed        
     - Report any side effects promptly        
     - Keep all follow-up appointments        
     - Inform your provider of any changes in your health status or medications        

    
    Consent
    By agreeing below, you acknowledge that you have read and understood the information provided in this consent form. You agree to proceed with treatment under the conditions outlined above.
    `,
    field: 'menHairLoss_consent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_consent_non_consent',
          class: 'option-decline',
          value: 'I have read the above information and do NOT wish to proceed'
        },
        {
          key: 'menHairLoss_consent_consent',
          class: 'option-consent',
          value:
            'I have read the above information, understand the risks, and wish to proceed.'
        }
      ]
    }
  }
];

export default questionsModels;
// DELETE ME:  Keeping this here to keep track of past Payloads
// 321#MENSHAIRLOSSTESTING@1737578165562
// const test = {
//   Q1: 'What is your height in feet and inches?',
//   A1: '123',
//   Q2: 'What is your weight in pounds?',
//   A2: 123,
//   Q3: 'Which areas are affected by hair loss? POSSIBLE ANSWERS: Receding hairline; Thinning at the crown; Overall thinning; Other',
//   A3: 'Other',
//   Q4: 'Tell us more about the pattern of your hair loss',
//   A4: 'asd',
//   Q5: 'How long have you been experiencing hair loss? POSSIBLE ANSWERS: Less than 6 months; 6 months to 1 year; Over 1 year',
//   A5: '6 months to 1 year',
//   Q6: 'How much hair have you lost? POSSIBLE ANSWERS: A little (Only I notice it); Some (Those close to me notice it); A lot (It is obvious to everyone)',
//   A6: 'Some (Those close to me notice it)',
//   Q7: 'Do you believe your hair loss is due to: POSSIBLE ANSWERS: Genetics; Stress; Medical conditions; Medications; Nutritional deficiencies; Other',
//   A7: 'Other',
//   Q8: 'Tell us more about why you think you are losing hair',
//   A8: 'asd',
//   Q9: 'Do you have any scalp conditions such as psoriasis, dermatitis, and/or recent or current scalp infections? POSSIBLE ANSWERS: Yes; No',
//   A9: 'No',
//   Q10: 'Do you have excessive dandruff, scalp irritation, scalp redness, burning, pustules, or scarring? POSSIBLE ANSWERS: Yes; No',
//   A10: 'No',
//   Q11: 'Are you losing hair in different parts of your body? POSSIBLE ANSWERS: Yes; No',
//   A11: 'Yes',
//   Q12: 'Tell us more about your hair loss in other parts of your body.',
//   A12: 'asd',
//   Q13: 'Have you tried any treatments for hair loss before? POSSIBLE ANSWERS: Yes; No',
//   A13: 'Yes',
//   Q14: 'Tell us more about your previous treatment including product use, when, duration of use, and did you experience side effects?',
//   A14: 'asd',
//   Q15: 'Do you have any of the following medical conditions? (check all that apply) POSSIBLE ANSWERS: Current or history of prostate cancer; Liver disease such as liver cirrhosis; Kidney disease such as chronic kidney disease or kidney failure; Heart conditions or cardiovascular diseases; History of stroke; Pheochromocytoma (adrenal gland tumor); Pulmonary hypertension Erectile Dysfunction; None of these apply to me',
//   A15: 'Current or history of prostate cancer; Liver disease such as liver cirrhosis; Kidney disease such as chronic kidney disease or kidney failure',
//   Q16: 'Do you have a history of depression, bipolar disorder, anxiety, or other mood disorders? POSSIBLE ANSWERS: Yes; No',
//   A16: 'Yes',
//   Q17: 'Can you tell us more about your mood disorder and whether it is controlled or uncontrolled?',
//   A17: 'asd',
//   Q18: 'Do you plan on having children soon? POSSIBLE ANSWERS: Yes; No',
//   A18: 'Yes',
//   Q19: 'What other information or questions do you have for the doctor?',
//   A19: 'asd',
//   Q20: 'Consent Form for Hair Loss Treatment\n    Consent Form for Hair Loss Treatment\n\n    Purpose of Treatment\n    Finasteride: An oral medication that inhibits the conversion of testosterone to dihydrotestosterone (DHT), a hormone linked to hair loss. It helps slow hair loss and may promote regrowth.\n    Minoxidil: A topical solution that stimulates hair follicles to promote hair growth. It increases blood flow to the scalp.\n    GUK-Cu: A copper peptide complex believed to stimulate hair growth by enhancing blood flow and supporting scalp health.\n\n    Potential Benefits\n    These treatments aim to slow hair loss, promote new hair growth, and improve hair density and appearance.\n\n    Contraindications\n    Finasteride \n     - Individuals with liver disease        \n     - Those with a history of prostate cancer        \n     - Anyone allergic to finasteride or its components        \n     - Women who are or may become pregnant should not handle finasteride tablets    \n\n    Minoxidil        \n     - Individuals with scalp conditions like dermatitis or psoriasis        \n     - Those allergic to minoxidil or its components    \n    \n    GUK-Cu \n     - Should not be used by individuals allergic to copper peptides or any of its components    \n\n    Potential Risks and Side Effects\n    \n    Finasteride    \n     - Sexual dysfunction (decreased libido, erectile dysfunction)        \n     - Breast tenderness or enlargement        \n     - Depression or mood changes        \n     - Allergic reactions        \n     - Possible effect on PSA levels used in prostate cancer screening    \n    Minoxidil\n     - Scalp irritation, itching, or dryness        \n     - Unwanted facial or body hair growth        \n     - Changes in blood pressure or heart rate (rare)    \n    GUK-Cu\n     - Scalp irritation        \n     - Allergic reactions    \n\n    Monitoring and Follow-up\n    Regular monitoring is recommended to assess effectiveness and detect any side effects. Inform your healthcare provider of any adverse reactions or concerns.\n    Alternative Treatments\n     - Hair transplant surgery        \n     - Low-level laser therapy        \n     - Platelet-rich plasma (PRP) therapy        \n     - Lifestyle changes and acceptance of hair loss    \n\n    Patient Responsibilities   \n     - Use medications exactly as prescribed        \n     - Report any side effects promptly        \n     - Keep all follow-up appointments        \n     - Inform your provider of any changes in your health status or medications        \n\n    \n    Consent\n    By agreeing below, you acknowledge that you have read and understood the information provided in this consent form. You agree to proceed with treatment under the conditions outlined above.\n     POSSIBLE ANSWERS: I have read the above information, understand the risks, and wish to proceed.; I have read the above information and do NOT wish to proceed',
//   A20: 'I have read the above information, understand the risks, and wish to proceed.'
// };
